import React from 'react';

import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useCostContext } from './CostProvider';
import { useTranslation } from './i18n';
import { customizedType } from '../helpers/localeHelper';

const SelectedCount = ({ count, type }) => {
  const { t } = useTranslation();
  const { terminologies } = useCostContext();
  const text = t('SELECTED_COUNT', {
    count,
    type: customizedType(t, type, terminologies),
  });
  return (
    <div style={{ maxWidth: 180, pointerEvents: 'auto' }}>
      <OverflowTooltip content={text}>{text}</OverflowTooltip>
    </div>
  );
};

export default SelectedCount;
